import React, { Fragment } from 'react'
import { Breadcrumb, Button, Card, Col, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import { streamUrl } from '../../../../variables'
import style from '../../../../components/Sales/style.css'
import { idMaker, strVal } from '../../../../modules/Utils'
import { get, sumBy } from 'lodash'
import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'
import IconText from '../../../../elements/IconText'
import CustomSpin from '../../../../elements/CustomSpin'
import Status from '../../../../elements/Status'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import EmailCont from '../../../../components/Common/Email/EmailCont'
import RemittanceForm from '../../../../components/Purchasing/Remittance/AddRemittance/RemittanceForm'
import History from '../../../../components/Common/History'
import Authentication from '../../../../modules/Authentication'
import { withRouter } from 'react-router-dom'
import RemittanceLines from '../../../../components/Purchasing/Remittance/AddRemittance/Lines/RemittanceLines'
import Amount from '../../../../components/Common/Amount'
import { AddRemittanceContext } from '../../../Purchasing/Remittance/AddRemittance/AddRemittanceCont'
import EmailListCont from '../../../Main/Emails/EmailCont'

const { TabPane } = Tabs
const ids = idMaker()
const auth = new Authentication()

function AddRemittance (props) {
  const {
    type,
    lines,
    submitting,
    updating,
    fetching,
    fetchingActions,
    submit,
    fetch,
    update,
    formRef,
    showEmail,
    actions,
    remittance,
    handleActions,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
    isNew,
  } = React.useContext(AddRemittanceContext)

  const isConfirmed = ['Confirmed'].includes(remittance.status)
  const isUpdatable = actions.find(a => a.key === 'update')
  const Operations = ({ remittance, ...rest }) => {
    const ops = actions
      .filter(a => a.key !== 'update')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && remittance.status === 'Confirmed') {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>,
      )
    }

    remittance.status !== 'Confirmed' &&
    ops.push(
      <a
        target={'_blank'}
        href={`${streamUrl}pdf/${remittance._id}?access_token=${auth.getAccessToken()}`}>
        <IconText text={'PDF preview'} type={'file-pdf'}/>
      </a>,
    )
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <a onClick={showEmail}>
          <IconText text={'Send Email'} type={'mail'}/>
        </a>,
      )
    }
    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }

  const SubmitButton = () => (
    <Button
      style={{ float: 'right', marginBottom: 10 }}
      icon={'form'}
      loading={updating || submitting}
      type="primary"
      onClick={type !== 'edit' ? submit : update}>
      {type === 'edit' ? 'Apply Changes' : 'Submit'}
    </Button>
  )
  return (
    <CustomSpin spinning={fetching || fetchingActions}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/purchasing/remittance/#remittance`}>
              Remittances
            </Breadcrumb.Item>
            <Breadcrumb.Item>{type === 'new' ? 'New Remittance' : remittance.code}</Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New Remittance</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <h2 className={'icon-text-header'}>
                    <Icon
                      type="barcode"
                      style={{
                        marginRight: '5px',
                        color: '#08c',
                      }}
                    />
                    <Tooltip title="Remittance Code">{strVal(remittance, 'code')}</Tooltip>
                  </h2>
                  <Status value={strVal(remittance, 'status')}/>
                  <Operations
                    style={{ marginTop: '10px' }}
                    remittance={remittance}
                    status={strVal(remittance, 'status')}
                  />
                </h3>
              </Col>
              <Col span={5}>
                <Amount data={[{ name: 'Amount', amount: sumBy(lines, 'allocation') }]}/>
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <Card className={style.contentCard}>
        <Tabs
          defaultActiveKey={get(props, 'location.hash') || '#details'}
          onChange={key => props.history.push(key)}>
          <TabPane
            tab={
              <span>
                <Icon type="info-circle"/>
                Details
              </span>
            }
            key="#details">
            {(isUpdatable || isNew) && (
              <Row>
                <SubmitButton/>
              </Row>
            )}
            <RemittanceForm ref={formRef} {...props} />
            {(isUpdatable || isNew) && (
              <Row>
                <SubmitButton/>
              </Row>
            )}
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="ordered-list"/> Lines
              </span>
            }
            key="#lines">
            <RemittanceLines remittance={remittance} {...props} />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="copy"/>
                History
              </span>
            }
            key="#history">
            <History isArray={true} loading={fetching} owner={remittance}/>
          </TabPane>
          <TabPane tab="Email" key="email">
            <EmailListCont owner={remittance._id} />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="folder-open"/>
                Documents
              </span>
            }
            key="#docs">
            <DocumentsCont email={true} emailLabel={'Email with Remittance'} owner={remittance}/>
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default withRouter(AddRemittance)
